import React from "react";
import { Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useCustomerAuth } from "@/components/customer/CustomerAuthProvider";
import { useOrganizationBranding } from "@/hooks/useOrganizationBranding";
import { PortalLogin } from "@/components/customer/PortalLogin";
import { usePortalSession } from "@/hooks/usePortalSession";

export const PortalEntrypoint = () => {
  const { user, customer, loading } = useCustomerAuth();
  const { name: orgName, brandColorHex } = useOrganizationBranding();
  
  // Initialize session management
  usePortalSession();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <>
        <Helmet>
          <title>{orgName} — My Bridal Journey</title>
          <meta name="theme-color" content={brandColorHex} />
        </Helmet>
        <div className="min-h-screen flex items-center justify-center bg-gradient-elegant">
          <div className="text-center space-y-4">
            <div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full mx-auto"></div>
            <p className="text-sm text-muted-foreground">Loading your bridal portal...</p>
          </div>
        </div>
      </>
    );
  }

  // If authenticated, redirect to dashboard (router basename handles any /portal prefix).
  if (user && customer) {
    return <Navigate to="/dashboard" replace />;
  }

  // Not authenticated, show login form
  const handleLoginSuccess = (sessionData: any) => {
    console.log('Login success callback triggered with:', sessionData);
    // Let the CustomerAuthProvider handle the state updates naturally
    // The provider will detect the stored session and update state accordingly
  };

  return (
    <>
      <Helmet>
        <title>{orgName} — Sign In</title>
        <meta name="theme-color" content={brandColorHex} />
      </Helmet>
      <PortalLogin onSuccess={handleLoginSuccess} />
    </>
  );
};